<template>
    <div id="gameImg">
        <div class="game">
            <img :src="game.gameImg" alt="">
            <div class="gameName" :style="gameNameBg">{{game.gameName}}</div>
        </div>
        
    </div>
  
</template>

<script>


export default {
    name:'gameImg',
    props:{
        game:{
            type:[Object]
        }
    },
    data(){
        return{
            gameNameBg:{
                background: 'url('+require('../assets/image/'+this.$route.query.type+'/gameNameBg.png')+') no-repeat',
                backgroundSize:'100%'
            },
        }
    },
    mounted(){
        
    },

}
</script>

<style>

.game{
    width: 15.6rem;
    height: 8.3rem;
    background: #fff;
    position: relative;
    margin: 2.05rem auto 1.5rem;
}
.game img{
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.game .gameName{
    position: absolute;
    bottom: 0;
    left: -0.05rem;
    width: 15.65rem;
    height: 1.4rem;
    line-height: 1.4rem;
    font-size: 0.75rem;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
    /* background: linear-gradient(to bottom right, #3091A3,transparent); */
  
    background-size: 100%;
    padding-left: 0.45rem;
    box-sizing: border-box;
}

</style>